import { Directive, HostListener, Input } from '@angular/core';
import { Gtag } from 'angular-gtag';

@Directive({
  selector: '[appClickEvent]',
})
export class ClickEventDirective {
  @Input() eventName!: string;
  @Input() eventCategory?: string = 'engagement';
  @Input() eventParams: any = {};

  constructor(private gtag: Gtag) {}

  @HostListener('click')
  onClick() {
    this.gtag.event(this.eventName, {
      event_category: this.eventCategory,
      ...this.eventParams,
    });
  }
}
